import { Navigate, useParams } from 'react-router-dom';

import { CinemaNavigation } from '@/pages/CinemaShared';
import { ActivitiesPage } from '@/pages/CinemaActivitiesPage';
import { MoviesPage } from '@/pages/CinemaMoviesPage';
import { RoomsPage } from '@/pages/CinemaRoomsPage';
import { SeatMapsPage } from '@/pages/CinemaSeatMapsPage';
import { ShowtimesPage } from '@/pages/CinemaShowtimesPage';

const sections = ['activities', 'movies', 'rooms', 'seat-maps', 'showtimes'] as const;
type Section = (typeof sections)[number];

export function CinemaPage() {
  const { section, id } = useParams<{ section: string; id?: string }>();
  if (!section || !sections.includes(section as Section)) {
    return <Navigate to="/cinema/activities" replace />;
  }

  // Each section page seeds `editing` with `useState(createMode)`, which only
  // captures the INITIAL value. Without a key React reuses the instance when
  // navigating list -> /new, leaving `editing` false so the create form never
  // renders (header appears, fields do not). Keying forces a remount whenever
  // the section or the :id segment changes.
  const sectionKey = `${section}:${id ?? 'list'}`;

  return (
    <div className="space-y-6">
      <CinemaNavigation active={section as Section} />
      {section === 'activities' && <ActivitiesPage key={sectionKey} />}
      {section === 'movies' && <MoviesPage key={sectionKey} />}
      {section === 'rooms' && <RoomsPage key={sectionKey} />}
      {section === 'seat-maps' && <SeatMapsPage key={sectionKey} />}
      {section === 'showtimes' && <ShowtimesPage key={sectionKey} />}
    </div>
  );
}
